export const searchSettings = {
  options: {
    input: "",
    // types: ["(regions)"],
    componentRestrictions: { country: "au" },
  },
};
